(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-product-content"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var lb = document.getElementById('ss-lightbox');
    if (!lb) return;

    var lbVideo = lb.querySelector('.ss-lightbox__video');
    var lbClose = lb.querySelector('.ss-lightbox__close');
    var lbBackdrop = lb.querySelector('.ss-lightbox__backdrop');
    var lbPlayPause = document.getElementById('ss-lb-playpause');
    var lbMute = document.getElementById('ss-lb-mute');
    var lbStage = lb.querySelector('.ss-lightbox__stage');

    function openLightbox(src) {
      lbVideo.setAttribute('src', src);
      lbVideo.load();
      lb.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      lbVideo.muted = false;
      lbStage.removeAttribute('data-paused');
      lbStage.removeAttribute('data-muted');
      lbVideo.play().catch(function () {});
      lbClose.focus();
    }

    function closeLightbox() {
      lb.setAttribute('hidden', '');
      lbVideo.pause();
      lbVideo.removeAttribute('src');
      lbVideo.load();
      document.body.style.overflow = '';
    }

    document.querySelectorAll('.ss-pc__ugc-media[data-video-src]').forEach(function (card) {
      card.addEventListener('click', function () {
        var src = card.getAttribute('data-video-src');
        if (src) openLightbox(src);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var src = card.getAttribute('data-video-src');
          if (src) openLightbox(src);
        }
      });
    });

    function syncPlayPause() {
      if (lbVideo.paused) {
        lbStage.setAttribute('data-paused', '');
        if (lbPlayPause) lbPlayPause.setAttribute('aria-label', 'Play video');
      } else {
        lbStage.removeAttribute('data-paused');
        if (lbPlayPause) lbPlayPause.setAttribute('aria-label', 'Pause video');
      }
    }

    function syncMute() {
      if (lbVideo.muted) {
        lbStage.setAttribute('data-muted', '');
        if (lbMute) lbMute.setAttribute('aria-label', 'Unmute');
      } else {
        lbStage.removeAttribute('data-muted');
        if (lbMute) lbMute.setAttribute('aria-label', 'Mute');
      }
    }

    lbVideo.addEventListener('play', syncPlayPause);
    lbVideo.addEventListener('pause', syncPlayPause);

    lbVideo.addEventListener('click', function () {
      if (lbVideo.paused) { lbVideo.play().catch(function () {}); }
      else { lbVideo.pause(); }
    });

    if (lbPlayPause) {
      lbPlayPause.addEventListener('click', function () {
        if (lbVideo.paused) { lbVideo.play().catch(function () {}); }
        else { lbVideo.pause(); }
      });
    }

    if (lbMute) {
      lbMute.addEventListener('click', function () {
        lbVideo.muted = !lbVideo.muted;
        syncMute();
      });
    }

    lbClose.addEventListener('click', closeLightbox);
    lbBackdrop.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lb.hasAttribute('hidden')) closeLightbox();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-video-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var lb = document.getElementById('ss-lightbox');
    if (!lb) return;

    var lbVideo = lb.querySelector('.ss-lightbox__video');
    var lbClose = lb.querySelector('.ss-lightbox__close');
    var lbBackdrop = lb.querySelector('.ss-lightbox__backdrop');

    var shopBar = document.getElementById('ss-lightbox-shop');
    var shopImg = document.getElementById('ss-lb-shop-img');
    var shopName = document.getElementById('ss-lb-shop-name');
    var shopPrice = document.getElementById('ss-lb-shop-price');
    var shopBtn = document.getElementById('ss-lb-shop-btn');
    var lbPlayPause = document.getElementById('ss-lb-playpause');
    var lbMute = document.getElementById('ss-lb-mute');
    var lbStage = lb.querySelector('.ss-lightbox__stage');

    function openLightbox(src, shopData) {
      lbVideo.setAttribute('src', src);
      lbVideo.load();

      if (shopBar && shopData && shopData.url) {
        if (shopImg) { shopImg.src = shopData.img || ''; shopImg.style.display = shopData.img ? 'block' : 'none'; }
        if (shopName) shopName.textContent = shopData.name || '';
        if (shopPrice) shopPrice.textContent = shopData.price || '';
        if (shopBtn) shopBtn.href = shopData.url;
        shopBar.style.display = 'flex';
      } else if (shopBar) {
        shopBar.style.display = 'none';
      }

      lb.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      lbVideo.muted = false;
      lbStage.removeAttribute('data-paused');
      lbStage.removeAttribute('data-muted');
      lbVideo.play().catch(function () {});
      lbClose.focus();
    }

    function closeLightbox() {
      lb.setAttribute('hidden', '');
      lbVideo.pause();
      lbVideo.removeAttribute('src');
      lbVideo.load();
      document.body.style.overflow = '';
    }

    document.querySelectorAll('.ss-video__media--playable').forEach(function (card) {
      function getShopData() {
        return {
          url:   card.getAttribute('data-shop-url'),
          name:  card.getAttribute('data-shop-name'),
          price: card.getAttribute('data-shop-price'),
          img:   card.getAttribute('data-shop-img')
        };
      }
      card.addEventListener('click', function () {
        var src = card.getAttribute('data-video-src');
        if (src) openLightbox(src, getShopData());
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var src = card.getAttribute('data-video-src');
          if (src) openLightbox(src, getShopData());
        }
      });
    });

    function syncPlayPause() {
      if (lbVideo.paused) {
        lbStage.setAttribute('data-paused', '');
        if (lbPlayPause) lbPlayPause.setAttribute('aria-label', 'Play video');
      } else {
        lbStage.removeAttribute('data-paused');
        if (lbPlayPause) lbPlayPause.setAttribute('aria-label', 'Pause video');
      }
    }

    function syncMute() {
      if (lbVideo.muted) {
        lbStage.setAttribute('data-muted', '');
        if (lbMute) lbMute.setAttribute('aria-label', 'Unmute');
      } else {
        lbStage.removeAttribute('data-muted');
        if (lbMute) lbMute.setAttribute('aria-label', 'Mute');
      }
    }

    lbVideo.addEventListener('play', syncPlayPause);
    lbVideo.addEventListener('pause', syncPlayPause);

    lbVideo.addEventListener('click', function () {
      if (lbVideo.paused) { lbVideo.play().catch(function () {}); }
      else { lbVideo.pause(); }
    });

    if (lbPlayPause) {
      lbPlayPause.addEventListener('click', function () {
        if (lbVideo.paused) { lbVideo.play().catch(function () {}); }
        else { lbVideo.pause(); }
      });
    }

    if (lbMute) {
      lbMute.addEventListener('click', function () {
        lbVideo.muted = !lbVideo.muted;
        syncMute();
      });
    }

    lbClose.addEventListener('click', closeLightbox);
    lbBackdrop.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lb.hasAttribute('hidden')) closeLightbox();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
